import { createFileRoute } from "@tanstack/react-router";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { OnboardingAuthGate } from "@/components/onboarding/OnboardingAuthGate";
import { OnboardingName } from "@/components/onboarding/OnboardingName";
import { useOnboardingStepEvent } from "@/lib/useOnboardingStepEvent";

// Screen 1 (#601, doc-08 §2.2): name your publication. Onboarding sits
// outside `/dashboard/w/$workspaceId` (a flat-file route, mirroring
// `preview.$workspaceId.$postId.tsx`'s precedent for a workspace-scoped route
// deliberately outside the dashboard shell) so it renders full-bleed, without
// `AppShell`'s sidebar — it is not a dashboard surface, and giving it one
// would imply the dashboard is behind a gate. It is not: every screen here
// can be skipped.
//
// Lives at `/onboarding/$workspaceId/name`, not the bare `/onboarding/
// $workspaceId` its filename might suggest: TanStack Router's flat-file
// convention nests any `onboarding.$workspaceId.<segment>.tsx` route UNDER an
// `onboarding.$workspaceId.tsx` file that matches that shared prefix exactly,
// rendering it only through that parent's `<Outlet/>`. This screen has no
// outlet (it is a leaf, like the other three), so keeping the bare path here
// would have silently swallowed screens 2, 3 and 4. The explicit `/name`
// segment keeps all four screens genuine path siblings — which is also what
// let `/updates` be added as one more sibling rather than a nested child.
export const Route = createFileRoute("/onboarding/$workspaceId/name")({
  ssr: false,
  beforeLoad: guardWorkspaceAccess,
  component: OnboardingNameRoute,
});

function OnboardingNameRoute() {
  useOnboardingStepEvent("name");
  const { workspaceId } = Route.useParams();
  return (
    <OnboardingAuthGate>
      <OnboardingName workspaceId={workspaceId} />
    </OnboardingAuthGate>
  );
}
